<ng-container *ngIf="data && parts">
  <!-- [2.1] 代表者連絡先情報ヘッダ -->
  <div class="p-booking-info-mdl__item">
    <button
      id="representative-information-open-button1"
      aria-controls="drawer-representative-information"
      [attr.aria-expanded]="isOpen"
      (click)="onClickShutter()"
      [ngClass]="['p-booking-info-mdl__open', isOpen ? 'is-open' : '']"
    >
      <span class="p-booking-info-mdl__open-head">
        <span
          class="p-booking-info-mdl__open-title"
          [innerHTML]="'label.representativeSelectionGroup' | staticMsg"
        ></span>
      </span>
      <!-- [2.2] 編集中表示 & (2.3) 開く -->
      <span
        *ngIf="parts.registrationLabel"
        [ngClass]="['p-booking-info-mdl__open-state', parts.registrationClass]"
        [innerHTML]="parts.registrationLabel | staticMsg"
      ></span>
      <span
        *ngIf="!isOpen"
        class="u-visually-hidden"
        [innerHTML]="'label.representativeSelectionGroup' | staticMsg"
      ></span>
    </button>
    <!-- [2.4] 代表者連絡先情報詳細 -->
    <div id="drawer-representative-information" [ngClass]="['p-booking-info-mdl__contents', isOpen ? 'is-open' : '']">
      <div class="p-booking-info-mdl__item-head">
        <div class="p-booking-info-mdl__item-head-wrap">
          <h2
            class="p-booking-info-mdl__item-head-title"
            [innerHTML]="'label.representativeSelectionGroup' | staticMsg"
          ></h2>
        </div>
        <div
          class="p-booking-info-mdl__item-head-status"
          *ngIf="parts.registrationLabel !== ''"
          [innerHTML]="parts.registrationLabel | staticMsg"
        ></div>
      </div>

      <div class="p-booking-info-mdl__section">
        <p
          class="p-booking-info-mdl__text"
          [innerHTML]="'label.representativeSelectionGroup.complement' | staticMsg"
        ></p>
      </div>
      <!-- [2.5] 予約基本情報詳細(代表者連絡先情報) -->
      <div
        class="p-booking-info-mdl__usual"
        *ngIf="data.basicReservationContactInfo && parts.isDisplayBasicReservation"
      >
        <div class="c-usual-information01">
          <h3 class="c-usual-information01__title" [innerHTML]="'label.usualInformation' | staticMsg"></h3>
          <div class="c-usual-information01__body">
            <dl class="c-def-list01">
              <div class="c-def-list01__item">
                <dt
                  class="c-def-list01__item-title"
                  [innerHTML]="'heading.contactRepresentativeInformation' | staticMsg"
                ></dt>
                <dd class="c-def-list01__item-body">
                  <dl class="c-float-list01">
                    <!-- [2.6] メールアドレス -->
                    <div class="c-float-list01__item">
                      <dt
                        class="c-float-list01__title c-float-list01__title--gray70"
                        [innerHTML]="'label.eMail.passengerInput' | staticMsg"
                      ></dt>
                      <dd
                        class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                        [innerHTML]="basicReservationContactInfoEmail"
                      ></dd>
                    </div>
                    <!-- [2.7] 電話番号 -->
                    <div class="c-float-list01__item">
                      <dt
                        class="c-float-list01__title c-float-list01__title--gray70"
                        [innerHTML]="'label.telephoneNumber.passengerInput' | staticMsg"
                      ></dt>
                      <dd
                        class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                        [innerHTML]="basicReservationContactInfoPhoneLabel"
                      ></dd>
                    </div>
                  </dl>
                </dd>
              </div>
            </dl>
          </div>
          <div class="c-usual-information01__btn">
            <!-- [2.8] 反映(代表者連絡先情報) -->
            <asw-button
              type="primary"
              size="s-min-w100"
              [label]="'label.enter' | staticMsg"
              (click$)="onClickEnterBasicReservationContactInfo()"
            ></asw-button>
          </div>
        </div>
      </div>
      <div class="p-booking-info-mdl__section">
        <form [formGroup]="formGroup">
          <div class="p-booking-info-mdl__block">
            <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
              <h3 class="p-booking-info-mdl__heading-title">
                {{ 'label.eMail.passengerInput' | staticMsg }}
                <!-- [2.9] ヘルプアイコン ※代表者メールアドレス -->
                <asw-tooltip
                  iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                    'm_static_message-alt.helpIcon2' | staticMsg
                  }} width=&quot;20&quot; height=&quot;20&quot;>"
                  [tooltipContent]="'tooltip.upgradeNotificationEmail' | staticMsg"
                  [displayAreaClass]="'p-booking-info-mdl__contents'"
                ></asw-tooltip>
              </h3>
              <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
            </div>
            <ng-container *ngIf="data.emails.length < 2; else emailLabel">
              <!-- [2.10] 代表者メールアドレス -->
              <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
                <div class="p-booking-info-mdl__row-item">
                  <asw-input
                    [label]="'label.eMailAddress.passengerInput' | staticMsg"
                    [placeholder]="'placeholder.eMailAddress' | staticMsg"
                    [formControlName]="REPRESENTATIVE_FORMS.EMAIL"
                    (change$)="onChangeEmailAddress()"
                    maxlength="50"
                    [conversionType]="'email'"
                  ></asw-input>
                </div>
              </div>
              <!-- [2.11] 代表者メールアドレス(確認用) -->
              <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
                <div class="p-booking-info-mdl__row-item">
                  <div class="c-form-element-input">
                    <asw-input
                      [label]="'label.confirmMailAddress' | staticMsg"
                      [placeholder]="'placeholder.eMailAddress' | staticMsg"
                      [formControlName]="REPRESENTATIVE_FORMS.CONFIRM_EMAIL"
                      (change$)="onChangeEmailConfirmAddress()"
                      maxlength="50"
                      [conversionType]="'email'"
                      disablePaste
                    ></asw-input>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- [2.10] 代表者メールアドレス -->
            <ng-template #emailLabel>
              <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
                <dl class="c-float-list01">
                  <ng-container *ngFor="let email of data.emails">
                    <div class="c-float-list01__item">
                      <dd
                        class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                        [innerHTML]="email.email"
                      ></dd>
                    </div>
                  </ng-container>
                </dl>
              </div>
            </ng-template>
          </div>
          <!-- [2.12] 代表者電話番号情報 -->
          <div *ngIf="parts.isDisplayPhone" class="p-booking-info-mdl__block">
            <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
              <h3
                class="p-booking-info-mdl__heading-title"
                [innerHTML]="'label.telNumber.passengerInput' | staticMsg"
              ></h3>
              <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
            </div>
            <ng-container *ngIf="data.phones.length < 2; else phoneLabel">
              <!-- [2.13] 代表者電話番号種別 -->
              <div class="p-booking-info-mdl__row p-booking-info-mdl__row--mb16">
                <div class="p-booking-info-mdl__row-item">
                  <asw-radiobutton-box
                    [legend]="'label.telNumber.passengerInput' | staticMsg"
                    [text]="phoneTypeLabelDisplay"
                    (changeEvent)="onChangePhoneType($event)"
                    [errorMessage]="radioBoxErrorInfo"
                    [selectedItem]="selectedPhoneType"
                  ></asw-radiobutton-box>
                </div>
              </div>
              <!-- [2.14] 代表者電話番号国 -->
              <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
                <div class="p-booking-info-mdl__row-item">
                  <asw-select
                    [label]="'label.countryCode' | staticMsg"
                    [formControlName]="REPRESENTATIVE_FORMS.PHONE_COUNTRY_CODE"
                    (change$)="onChangeCountry($event)"
                  >
                    <option
                      *ngFor="let phoneCountryInfo of phoneCountries"
                      [value]="phoneCountryInfo.country2LetterCode"
                      [innerHTML]="phoneCountryInfo.countryName"
                    ></option>
                  </asw-select>
                </div>
              </div>
              <!-- [2.15] 代表者電話番号の国番号 & (2.16) 代表者電話番号 -->
              <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
                <div class="p-booking-info-mdl__row-item">
                  <span
                    class="u-visually-hidden"
                    [innerHTML]="'reader.telephoneNumber.passengerInput' | staticMsg"
                  ></span>
                  <asw-input
                    [label]="'label.telephoneNumber.passengerInput' | staticMsg"
                    [formControlName]="REPRESENTATIVE_FORMS.PHONE_NUMBER"
                    [placeholder]="'placeholder.phoneNumber.international' | staticMsg"
                    displayType="phone"
                    phoneCode="+{{ countryPhoneExtension }}"
                    maxlength="16"
                    (change$)="onChangePhoneNumber()"
                    [conversionType]="'phoneNumber'"
                  ></asw-input>
                </div>
              </div>
            </ng-container>
            <ng-template #phoneLabel>
              <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
                <dl class="c-float-list01">
                  <ng-container *ngFor="let phone of data.phones">
                    <div class="c-float-list01__item">
                      <dd
                        class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                        [innerHTML]="getPhoneInfoLabel(phone)"
                      ></dd>
                    </div>
                  </ng-container>
                </dl>
              </div>
            </ng-template>
          </div>
        </form>
      </div>

      <div class="p-booking-info-mdl__section">
        <div class="p-booking-info-mdl__block">
          <div class="p-booking-info-mdl__close">
            <button
              id="representative-information-close-button1"
              class="p-booking-info-mdl__close-btn"
              aria-controls="drawer-representative-information"
              aria-expanded="true"
              (click)="onClickShutter()"
            >
              <span class="p-booking-info-mdl__close-text" [innerHTML]="'label.fold' | staticMsg"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
